import React from 'react';
import { SpinnerIcon } from '@ds-icons';
import { ILoader } from './Loader.types';
import styles from './Loader.module.scss';

const LoaderDefaultSize = 32;

export const Loader: React.FC<ILoader> = ({ size = LoaderDefaultSize, className = '' }) => {
  const iconSize = { width: size, height: size };
  return (
    <div className={className} data-testid="loader">
      <img style={iconSize} src={SpinnerIcon} className={styles['spinner-icon']} alt="Loader" />
    </div>
  );
};
